import React, { useState, useEffect } from 'react';
import { config } from "../../../utils/apiUrl";
import API from "../../../utils/apiCalling";
import "./surveyPage.css"
const SurveyPage = (props) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [isNext, setIsNext] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setISsuccess] = useState(false);
  const [SurveyPageData, setSurveyPageData] = useState([]);
  const [banner, setBanner] = useState('');
  const [warning, setWarning] = useState('none');
  const [disclaimer, setDisclaimer] = useState('');
  const [completionText, setCompletionText] = useState('');
  const [boxTips, setBoxTips] = useState(false);
  const [submitData, setSubmitData] = useState({
    "tab": {
      "id": 3,
      "name": "Submit",
      "sort": 3,
      "update_time": "2024-09-04T03:01:03.000Z"
    },
    "questions": [{
      "id": 2,
      "name": "Name",
      "type": 2,
      "tab_id": "3",
      "tab_name": "Submit",
      "pre_answer_id": "0",
      "sort": 1,
      "update_time": "2024-09-12T07:22:35.000Z",
       "msg":'',
      "answers": []
    }, {
      "id": 3,
      "name": "Email address",
      "type": 2,
      "tab_id": "3",
      "tab_name": "Submit",
      "pre_answer_id": "0",
      "sort": 2,
      "update_time": "2024-09-12T07:23:45.000Z",
      "msg":'',
      "answers": []
    }, {
      "id": 5,
      "name": "Mobile number",
      "type": 2,
      "tab_id": "3",
      "tab_name": "Submit",
      "pre_answer_id": "0",
      "sort": 3,
      "update_time": "2024-09-26T03:14:03.000Z",
      "msg":'',
      "answers": []
    }]
  });
  useEffect(() => {
    window.scrollTo(0, 0)
    window.addEventListener('scroll',(e)=>{
      if(document.body.clientWidth<500){
        if(window.scrollY>110){
          var _dom = document.getElementById('fixed')
          _dom.className='SurveyPage_fixed'
        }else{
          var _dom = document.getElementById('fixed')
          _dom.className=''
        }
      }else{
        var _dom = document.getElementById('fixed')
          _dom.className=''
      }
    })
  }, [])

  const api = new API();
  const getSurveyPageData = async () => {
    let SurveyPageDatas = await api.get(config.SurveyPage, true);
    let SurveyPageData = SurveyPageDatas.data;
    let completion_text = SurveyPageDatas.completion_text;
    let disclaimer = SurveyPageDatas.disclaimer;
    setDisclaimer(disclaimer);
    setCompletionText(completion_text);
    for (let i = 0; i < SurveyPageData.length; i++) {
      for (let j = 0; j < SurveyPageData[i].questions.length; j++) {
        SurveyPageData[i].questions= SurveyPageData[i].questions.sort((a, b) => a.sort - b.sort)
        SurveyPageData[i].questions[j]['msg'] = '';
        if(SurveyPageData[i].questions[j]['pre_answer_id'] == '0'){
          SurveyPageData[i].questions[j]['submit']=true
        }else{
          SurveyPageData[i].questions[j]['submit']=false
        }
        for (let y = 0; y < SurveyPageData[i].questions[j].answers.length; y++) {
          SurveyPageData[i].questions[j].answers[y]['check'] = false;
          // if (SurveyPageData[i].questions[j].answers[y].name.toLowerCase() == 'other') {
          if (SurveyPageData[i].questions[j].answers[y].open_end == 1) {
            SurveyPageData[i].questions[j].answers[y]['msg'] = '';
          }
        }
      }
    }
    setSurveyPageData(SurveyPageData)
  }
  const getBanner = async () => {
    let SurveyPageData = await api.get(config.SurveyBanner, true);
    setBanner(SurveyPageData)
  }
  const changeTab = (i) => {
    if (!isNext) {
      setTabIndex(i)
      window.scrollTo(0, 0)
    }
  }
  useEffect(() => {
    getSurveyPageData()
    getBanner()
  }, [])
  const setAnswer = (tab, value, name, qIndex, wIndex) => {
    if (tab != 100) {
      let NewData = [ ...SurveyPageData ];
      if (name == 'text') {
        NewData[tab].questions[qIndex]['answers'][wIndex]['msg'] = value;
      } else if (name == 'textarea') {
        NewData[tab].questions[qIndex]['msg'] = value
      } else if (name == 'radio') {
        let arr = NewData[tab].questions[qIndex]['answers'].forEach((item, i) => {
          item.check = false
        });
        NewData[tab].questions[qIndex]['answers'][wIndex]['check'] = value.target.checked;
      } else if (name == 'checkbox') {
        NewData[tab].questions[qIndex]['answers'][wIndex]['check'] = value.target.checked;
      }
      for(let j =0;j<NewData.length;j++){
        let dataArray = NewData[j].questions.forEach((item, i) => {
            let arr = NewData[tab].questions[qIndex]['answers'].forEach((e,i)=>{
              if(e.check==true){
                if(e.id==item.pre_answer_id){
                  item.submit=true
                }
              }else{
                if(e.id==item.pre_answer_id){
                  item['answers'].forEach((q,b)=>{
                    q.check=false;
                  })
                  item.submit=false;
                  item.msg='';
                }
              }
            })
      });
      }
      setSurveyPageData(NewData)
    } else{
      let NewData = { ...submitData };
      if (name == 'text') {
        NewData.questions[qIndex]['answers'][wIndex]['msg'] = value
      } else if (name == 'textarea') {
        NewData.questions[qIndex]['msg'] = value
      } else if (name == 'radio') {
        let arr = NewData.questions[qIndex]['answers'].forEach((item, i) => {
          item.check = false
        });
        NewData.questions[qIndex]['answers'][wIndex]['check'] = value.target.checked;
      } else if (name == 'checkbox') {
        NewData.questions[qIndex]['answers'][wIndex]['check'] = value.target.checked;
      }
      setSubmitData(NewData)
    }
  }
  const submit = async () => {
    var DOM = document.querySelectorAll('.warning');
    var validated = true;
    setWarning('inline-block')
    DOM.forEach((v, i) => {
      if (v.innerHTML != '') {
        validated = false;
      }
    })
    if(!isSubmit){
      setBoxTips(true)
    }
    if (isSubmit && validated) {
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([...SurveyPageData,submitData]),
      };
      const response = await fetch(config.SurveyPageSubmit, options);
      response.status == 200 && setIsNext(true)
      setISsuccess(true)
      setTabIndex(null)
      setBoxTips(false)
      window.scrollTo(0, 0)
    }
  }
  const changeSubmitValue = (v) => {
    setIsSubmit(v)
    setBoxTips(!v)
  }
  const getPlaceholder = (v) => {
    if (v.indexOf('Name') != -1) {
      return 'Firstname Lastname'
    } else if (v.indexOf('Email') != -1) {
      return 'abc@email.com'
    } else {
      return '000-000-0000'
    }
  }
  const getTips = (n, v) => {
    if (n.indexOf('Name') != -1) {
      if (v.trim() != '') {
        return ''
      } else {
        return 'Please fill in.'
      }
    } else if (n.indexOf('Email') != -1) {
      var emailPat = /^(.+)@(.+)$/;
      var matchArray = v.match(emailPat);
      if (matchArray) {
        return ''
      } else {
        return 'Email is required. Please fill in.'
      }
    } else {
      if (v.trim() != '') {
        return ''
      } else {
        return 'Mobile is required. Please fill in.'
      }
    }
  }
  return (
    <>
      <div id="SurveyPage" className="pageobj" style={{}}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12" style={{ padding: '0px' }}>
              <div className='banner'>
                {/* <img src={'data:image/png;base64,'+banner} alt="" /> */}
                <img src={banner} alt="" />
              </div>
            </div>
          </div>
          <div className="row" id='fixed' style={{background: '#fff'}}>
            <div className="col-md-10" style={{ margin: '0 auto' }}>
              <div className="" style={{ margin: '0 auto', textAlign: 'center', lineHeight: '45px',display:'flex' }}>
                {
                  SurveyPageData.map((value,index)=>{
                    return(
                      <div className={tabIndex == index ? ' nav_test nav_active' : ' nav_test'} onClick={() => changeTab(index)}>
                      {
                        tabIndex == index ? (<img src="/img/home/circle.svg" alt="" className='nav_img' />) : (<img src="/img/home/check2.svg" alt="" className='nav_img' />)
                      }
                        <span>{value.tab.name}</span>
                      </div>
                      )
                  })
                }
                <div className={tabIndex == SurveyPageData.length ? ' nav_test nav_active' : ' nav_test'} onClick={() => changeTab(SurveyPageData.length)}>
                  {
                    tabIndex == SurveyPageData.length ? (<img src="/img/home/circle.svg" alt="" className='nav_img' />) : (<img src="/img/home/check2.svg" alt="" className='nav_img' />)
                  }
                  <span>Submit</span>
                </div>
              </div>
            </div>
          </div>
          {
            SurveyPageData.map((value,index)=>{
              return (
                <div className="row" style={{ display: tabIndex == index ? 'block' : 'none' }}>
                    <div className="col-md-12" style={{ background: '#fff' }}>
                      <div className='section' style={{marginTop:'0px'}}>
                        <div style={{ borderBottom: '1px solid #a9d1d3' }}>
                          {/* <p style={{ color: '#29949e', fontSize: '20px' }}>Please respond to each question as accurately as you can</p> */}
                          <h2>{value.tab.name}</h2>
                        </div>
                        {
                          value.questions.map((d, i2) => {
                            return (
                              <div style={{ borderBottom: '1px solid #a9d1d3', padding: '25px 0px',display:(d.submit)?'block':'none' }}>
                                <h4 style={{ color: '#666666' }}>{d.name}</h4>
                                {
                                  d.type == 2 && (
                                    <div> 
                                      <textarea name="showText" rows="10" placeholder='Your answer' maxLength="3000" value={d.msg} onChange={(e) => setAnswer(index, e.target.value, 'textarea', i2)} style={{ width: '100%' }}></textarea>
                                      <p>{d.msg.length} of 3000 max characters</p>
                                    </div>
                                  )
                                }
                                {
                                  d.type != 2 &&
                                  d.answers.map((v, i3) => {
                                    return (
                                      <div style={{ margin: '5px 0px', fontSize: '18px', color: '#000' }}>
                                        <input type={d.type == 0 ? 'radio' : 'checkbox'} checked={v.check?'checked':null} onChange={(e) => { setAnswer(index, e, d.type == 0 ? 'radio' : 'checkbox', i2, i3) }} value={d.name} name={d.tab_name + i2} />
                                        &nbsp;
                                        {v.name}
                                        {
                                          v.open_end == 1 &&  v.check==true && <div style={{ marginLeft: '15px', marginTop: '5px' }}> <input type='text' value={v.msg} onChange={(e) => setAnswer(index, e.target.value, 'text', i2, i3)} placeholder='Your answer' style={{ width: '30%', fontSize: '14px' }} /></div>
                                        }
                                      </div>
                                    )
                                  })
                                }
                              </div>
                            )
                          })
                        }
                        <div>
                          {index!=0 &&<input type="button" className='btn btn-primary' value='Previous' style={{marginRight:'15px'}} onClick={() => changeTab(index-1)} />}
                          <input type="button" className='btn btn-primary' value='Next' onClick={() => changeTab(index+1)} /></div>
                      </div>
                    </div>
                  </div>
              )
            })
          }
          <div className="row" style={{ display: tabIndex == SurveyPageData.length ? 'block' : 'none' }}>
            <div className="col-md-12" style={{ background: '#fff' }}>
              <div className='section'  style={{marginTop:'0px'}}>
                <div style={{ borderBottom: '1px solid #a9d1d3' }}>
                  <p style={{ color: '#29949e', fontSize: '20px' }}>Please fill in the required information, subscribe, and submit</p>
                  <h2>Submit</h2>
                </div>
                {
                  submitData && submitData.questions.map((d, index) => {
                    return (
                      <div style={{ borderBottom: '1px solid #a9d1d3', padding: '25px 0px'}}>
                        <h4 style={{ color: '#666666' }}>{d.name}</h4>
                        {
                          d.type == 2 && (
                            <div>
                              <input name="showText" type='text' rows="10" placeholder={getPlaceholder(d.name)} value={d.msg} onChange={(e) => setAnswer(100, e.target.value, 'textarea', index)} style={{ width: '40%' }}></input>
                              <span style={{ marginLeft: '5px', color: 'red',display:warning }} className='warning' name={getTips(d.name, d.msg)}>{getTips(d.name, d.msg)}</span>
                            </div>


                          )
                        }
                        {/* {
                          d.type != 2 &&
                          d.answers.map((v, i) => {
                            return (
                              <div style={{ margin: '5px 0px', fontSize: '18px', color: '#000' }}>
                                <input type={d.type == 0 ? 'radio' : 'checkbox'} onChange={(e) => { setAnswer(100, e, d.type == 0 ? 'radio' : 'checkbox', index, i) }} value={d.name} name={d.tab_name + '_index'} />
                                &nbsp;
                                {v.name}
                                {
                                  v.name == 'other' &&<div style={{ marginLeft: '15px' }}> <input type='text' value={v.msg} onChange={(e) => setAnswer(100, e.target.value, 'text', index, i)} placeholder='Your answer' /></div>
                                }
                              </div>
                            )
                          })
                        } */}
                      </div>
                    )
                  })
                }
                <div style={{ borderBottom: '1px solid #a9d1d3', padding: '25px 0px' }}>
                  <div><input type='checkbox' value={isSubmit} onChange={(e) => { changeSubmitValue(e.target.checked) }} /> <span>By ticking, you are confirming to subscribe to the newsletter and that you have read, understood, and agreed to the <a href="/about/terms-of-use">terms and conditions</a></span></div>
                  {boxTips&&<p style={{color:'red'}}>Tick is required. Please tick the box.</p>}
                  <div  dangerouslySetInnerHTML={{__html:disclaimer}} style={{marginTop:'10px'}}></div>
                  <div><input type="button" className='btn btn-primary' value='Subscribe and submit' style={{ marginTop: '30px', padding: '10px 20px', fontSize: '25px' }} onClick={submit} /></div>
                </div>
                <div><input type="button" className='btn btn-primary' value='Previous' onClick={() => changeTab(SurveyPageData.length-1)} /></div>
              </div>
            </div>
          </div>
          <div className="row" style={{ display: success==true  ? 'block' : 'none' }}>
            <div className="col-md-12" style={{ background: '#fff', padding: '0px' }}>
              <div className='section'>
                <div style={{ borderBottom: '1px solid #a9d1d3' }}>
                  <p style={{ color: '#29949e', fontSize: '20px' }}>Successfully submitted</p>
                  <h2 style={{ fontWeight: 'bold' }}>Thank you for completing the survey!</h2>
                </div>
                <div dangerouslySetInnerHTML={{__html:completionText}} style={{marginTop:'10px'}}></div>
              </div>
              <div style={{ background: '#a3d4d9' }}>
                <div style={{ padding: '20px 20px' }}>
                  <span style={{ color: '#004559', fontSize: '20px', fontWeight: 'bold' }}>Follow our social medias </span>
                  <span style={{ fontSize: '18px' }}>to receive daily updates and insights on the warrants market, and stay tuned
                    for more exciting warrant contests!
                  </span>
                  <div className='sharebtns'>
                    <a target="_black" class="sharebtn-tl btn" type="button" href="/telegram"></a>
                    <a target="_black" class="sharebtn-fb btn" type="button" href="https://www.facebook.com/MalaysiaWarrants/"></a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
export default SurveyPage;
